export default "__VITE_ASSET__DXatvcUP__"